export default "__VITE_ASSET__C1Efho60__"